import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import enGlobal from './assets/locales/en.json'
import esGlobal from './assets/locales/es.json'
import ptGlobal from './assets/locales/pt.json'
import brandSelectEn from './components/brand-select/locales/en.json'
import brandSelectEs from './components/brand-select/locales/es.json'
import brandSelectPt from './components/brand-select/locales/pt.json'
import cardBrandEn from './components/card-brand/locales/en.json'
import cardBrandEs from './components/card-brand/locales/es.json'
import cardBrandPt from './components/card-brand/locales/pt.json'
import cardMediaKitEn from './components/card-mediakit/locales/en.json'
import cardMediaKitEs from './components/card-mediakit/locales/es.json'
import cardMediaKitPt from './components/card-mediakit/locales/pt.json'
import cardToCreateMediaKitEn from './components/card-to-create-instagram-mediakit/locales/en.json'
import cardToCreateMediaKitEs from './components/card-to-create-instagram-mediakit/locales/es.json'
import cardToCreateMediaKitPt from './components/card-to-create-instagram-mediakit/locales/pt.json'
import emptyLinkedInstagramEn from './components/empty-mediakit/locales/en.json'
import emptyLinkedInstagramEs from './components/empty-mediakit/locales/es.json'
import emptyLinkedInstagramPt from './components/empty-mediakit/locales/pt.json'
import modalStatisticsEn from './components/modal-statistics/locales/en.json'
import modalStatisticsEs from './components/modal-statistics/locales/es.json'
import modalStatisticsPt from './components/modal-statistics/locales/pt.json'
import onboardingMediaKitEn from './components/onboarding-mediakit/locales/en.json'
import onboardingMediaKitEs from './components/onboarding-mediakit/locales/es.json'
import onboardingMediaKitPt from './components/onboarding-mediakit/locales/pt.json'
import photoCommentsEn from './components/photo-comments-instagram/locales/en.json'
import photoCommentsEs from './components/photo-comments-instagram/locales/es.json'
import photoCommentsPt from './components/photo-comments-instagram/locales/pt.json'
import photoGridEn from './components/photo-grid/locales/en.json'
import photoGridEs from './components/photo-grid/locales/es.json'
import photoGridPt from './components/photo-grid/locales/pt.json'
import photoLegendEn from './components/photo-legend/locales/en.json'
import photoLegendEs from './components/photo-legend/locales/es.json'
import photoLegendPt from './components/photo-legend/locales/pt.json'
import detailMediaKitPageEn from './pages/detail-mediakit/locales/en.json'
import detailMediaKitPageEs from './pages/detail-mediakit/locales/es.json'
import detailMediaKitPagePt from './pages/detail-mediakit/locales/pt.json'
import aboutMediaKitPageEn from './pages/detail-mediakit/pages/about/locales/en.json'
import aboutMediaKitPageEs from './pages/detail-mediakit/pages/about/locales/es.json'
import aboutMediaKitPagePt from './pages/detail-mediakit/pages/about/locales/pt.json'
import analyticsMediaKitPageEn from './pages/detail-mediakit/pages/analytics/locales/en.json'
import analyticsMediaKitPageEs from './pages/detail-mediakit/pages/analytics/locales/es.json'
import analyticsMediaKitPagePt from './pages/detail-mediakit/pages/analytics/locales/pt.json'
import brandsPageEn from './pages/detail-mediakit/pages/brands/locales/en.json'
import brandsPageEs from './pages/detail-mediakit/pages/brands/locales/es.json'
import brandsPagePt from './pages/detail-mediakit/pages/brands/locales/pt.json'
import communicationPageEn from './pages/detail-mediakit/pages/communication/locales/en.json'
import communicationPageEs from './pages/detail-mediakit/pages/communication/locales/es.json'
import communicationPagePt from './pages/detail-mediakit/pages/communication/locales/pt.json'
import coverMediaKitPageEn from './pages/detail-mediakit/pages/cover/locales/en.json'
import coverMediaKitPageEs from './pages/detail-mediakit/pages/cover/locales/es.json'
import coverMediaKitPagePt from './pages/detail-mediakit/pages/cover/locales/pt.json'
import whoDoesMediaKitPageEn from './pages/detail-mediakit/pages/who-does/locales/en.json'
import whoDoesMediaKitPageEs from './pages/detail-mediakit/pages/who-does/locales/es.json'
import whoDoesMediaKitPagePt from './pages/detail-mediakit/pages/who-does/locales/pt.json'
import listMediaKitEn from './pages/list-mediakit/locales/en.json'
import listMediaKitEs from './pages/list-mediakit/locales/es.json'
import listMediaKitPt from './pages/list-mediakit/locales/pt.json'

export const defaultNS = 'globalMediakit'
export const resources = {
  en: {
    globalMediakit: enGlobal,
    emptyLinkedInstagram: emptyLinkedInstagramEn,
    onboardingMediaKit: onboardingMediaKitEn,
    photoGrid: photoGridEn,
    detailMediaKitPage: detailMediaKitPageEn,
    communicationPage: communicationPageEn,
    coverMediaKitPage: coverMediaKitPageEn,
    aboutMediaKitPage: aboutMediaKitPageEn,
    whoDoesMediaKitPage: whoDoesMediaKitPageEn,
    cardToCreateMediaKit: cardToCreateMediaKitEn,
    cardMediaKit: cardMediaKitEn,
    listMediaKit: listMediaKitEn,
    photoLegend: photoLegendEn,
    photoComments: photoCommentsEn,
    cardBrand: cardBrandEn,
    brandSelect: brandSelectEn,
    brandsPage: brandsPageEn,
    analyticsMediaKitPage: analyticsMediaKitPageEn,
    modalStatistics: modalStatisticsEn,
  },
  pt: {
    globalMediakit: ptGlobal,
    emptyLinkedInstagram: emptyLinkedInstagramPt,
    onboardingMediaKit: onboardingMediaKitPt,
    photoGrid: photoGridPt,
    detailMediaKitPage: detailMediaKitPagePt,
    communicationPage: communicationPagePt,
    coverMediaKitPage: coverMediaKitPagePt,
    aboutMediaKitPage: aboutMediaKitPagePt,
    whoDoesMediaKitPage: whoDoesMediaKitPagePt,
    cardToCreateMediaKit: cardToCreateMediaKitPt,
    cardMediaKit: cardMediaKitPt,
    listMediaKit: listMediaKitPt,
    photoLegend: photoLegendPt,
    photoComments: photoCommentsPt,
    cardBrand: cardBrandPt,
    brandSelect: brandSelectPt,
    brandsPage: brandsPagePt,
    analyticsMediaKitPage: analyticsMediaKitPagePt,
    modalStatistics: modalStatisticsPt,
  },
  es: {
    globalMediakit: esGlobal,
    emptyLinkedInstagram: emptyLinkedInstagramEs,
    onboardingMediaKit: onboardingMediaKitEs,
    photoGrid: photoGridEs,
    detailMediaKitPage: detailMediaKitPageEs,
    communicationPage: communicationPageEs,
    coverMediaKitPage: coverMediaKitPageEs,
    aboutMediaKitPage: aboutMediaKitPageEs,
    whoDoesMediaKitPage: whoDoesMediaKitPageEs,
    cardToCreateMediaKit: cardToCreateMediaKitEs,
    cardMediaKit: cardMediaKitEs,
    listMediaKit: listMediaKitEs,
    photoLegend: photoLegendEs,
    photoComments: photoCommentsEs,
    cardBrand: cardBrandEs,
    brandSelect: brandSelectEs,
    brandsPage: brandsPageEs,
    analyticsMediaKitPage: analyticsMediaKitPageEs,
    modalStatistics: modalStatisticsEs,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'globalMediakit',
      'photoGrid',
      'emptyLinkedInstagram',
      'detailMediaKitPage',
      'cardMediaKit',
      'cardToCreateMediaKit',
      'coverMediaKitPage',
      'communicationPage',
      'aboutMediaKitPage',
      'whoDoesMediaKitPage',
      'onboardingMediaKit',
      'listMediaKit',
      'photoComments',
      'cardBrand',
      'brandSelect',
      'brandsPage',
      'analyticsMediaKitPage',
      'modalStatistics',
    ],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    lng: navigator.language?.split('-')[0] || 'en',
    fallbackLng: 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    resources,
  })

export default i18n
